import React, { useEffect, useState } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Table } from 'semantic-ui-react'
import { CoolFarmService } from '~/api/services/coolFarm'
import { FormFields } from '~/components/FormFields'
import { convertDate, handleErrors } from '~/utils/helpers'

const FarmerGroupInfo:React.FC = () => {
  const { control } = useFormContext()
  const { t } = useTranslation()

  const [isLoadingFarmerInfo, setIsLoadingFarmerInfo] = useState(false)
  const [farmerGroupsInfo, setFarmerGroupsInfo] = useState([])

  const watchIncludedFarmersCheck = useWatch({ control, name: 'includeFarmersWithCompletedFootprint' })
  const watchFarmersGroupSelected = useWatch({ control, name: 'farmerGroups' })
  const watchPeriodFrom = useWatch({ control, name: 'periodFrom' })
  const watchPeriodTo = useWatch({ control, name: 'periodTo' })

  const tableColumnHeaders = [
    {
      name: t('Farmer groups'),
      key: 'name'
    },
    {
      name: 'Anzahl Landwirte',
      key: 'totalFarmers'
    },
    {
      name: 'Anzahl der teilnehmenden Landwirte',
      key: 'canParticipateFarmers',
      type: 'farmer-participents'
    }
  ]

  useEffect(() => {
    if(watchFarmersGroupSelected &&
    watchPeriodFrom &&
    watchPeriodTo
    ) {
      fetchFarmerGroupInfo()
    }
  }, [
    watchFarmersGroupSelected,
    watchPeriodFrom,
    watchPeriodTo
  ])

  async function fetchFarmerGroupInfo() {
    setIsLoadingFarmerInfo(true)
    try {
      const response = await CoolFarmService.getFarmerList({
        periodFrom: convertDate(watchPeriodFrom),
        periodTo: convertDate(watchPeriodTo)
      })
      const farmerGroupsFiltered = response.data.reduce((previosValue, currentValue) => {
        if(watchFarmersGroupSelected.find(id => currentValue.id === id)) {
          return [...previosValue, { ...currentValue }]
        }
        return previosValue
      }, [])
      setFarmerGroupsInfo(farmerGroupsFiltered)
    } catch(error) {
      handleErrors(error)
    }
    setIsLoadingFarmerInfo(false)
  }

  function getFarmerParticipientsValue(farmerGroupInfo) {
    const { canParticipateFarmers, totalFarmers } = farmerGroupInfo

    if(!watchIncludedFarmersCheck) {
      return `${canParticipateFarmers} (${totalFarmers})`
    }

    return `${totalFarmers} (${totalFarmers})`
  }

  function renderBody() {
    return farmerGroupsInfo.map(farmerGroupInfo => {
      return <Table.Row key={farmerGroupInfo.id}>
        {tableColumnHeaders.map(tableColumnHeader => {
          const value = tableColumnHeader.type === 'farmer-participents' ?
            getFarmerParticipientsValue(farmerGroupInfo) :
            farmerGroupInfo[tableColumnHeader.key]
          return <Table.Cell key={`${farmerGroupInfo.id}-${tableColumnHeader.key}`}>
            {value}
          </Table.Cell>
        })}
      </Table.Row>
    })
  }

  function renderTable() {
    return <Table celled>
      <Table.Header>
        <Table.Row>
          {tableColumnHeaders.map(tableColumnHeader => {
            return <Table.HeaderCell key={tableColumnHeader.key}>{tableColumnHeader.name}</Table.HeaderCell>
          })}
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {renderBody()}
      </Table.Body>
    </Table>
  }

  return <div style={{ margin: '2em 0em' }}>
    <FormFields.Checkbox
      control={control}
      label={'Landwirte mit bestehenden CO2-Fußabdruck im Betrachtungszeitraum ebenfalls berücksichtigen?'}
      name={'includeFarmersWithCompletedFootprint'}
      defaultValue={0}
      checkboxValue={1}
    />
    {renderTable()}
  </div>
}
export default FarmerGroupInfo